exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#map {\n  height: 250px;\n  width: 80%;\n  border-radius: 5%;\n  margin: 0 auto; }\n\n.centered {\n  text-align: center;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  -ms-flex-line-pack: center;\n      align-content: center; }\n\n.bg {\n  color: white;\n  font-family: 'Inconsolata', monospace;\n  /* The image used */\n  background-image: url(" + require("../../assets/wow.png") + ");\n  /* Full height */\n  height: 100%;\n  /* Center and scale the image nicely */\n  background-position: center;\n  background-repeat: no-repeat;\n  background-size: cover;\n  background-position: 0px 0px;\n  background-repeat: repeat-x;\n  -webkit-animation: animatedBackground 30s linear infinite;\n          animation: animatedBackground 30s linear infinite; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /Users/jmiller/Projects/Real/j-trip/j-trip/src/app/moment-card/moment-card.component.scss
// module id = ../../../../../src/app/moment-card/moment-card.component.scss
// module chunks = main